class LoadMore extends HTMLElement {
    constructor() {
      super();
  
      // Initialize variables
      this.productGrid = document.querySelector('.product-grid');
      this.loadMoreButton = this.querySelector('button');
      this.nextUrl = this.loadMoreButton.dataset.nextUrl;
      this.behaviorButton = this.getAttribute('data-behavior') === 'button';
      this.behaviorInifiniteScroll = this.getAttribute('data-behavior') === 'infinite';
  
      // Initialize Intersection Observer
      this.infiniteScrollObserver = new IntersectionObserver(
        entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              // Trigger loadMoreProducts when the observed element intersects with the viewport
              this.loadMoreProducts();
            }
          });
        },
        { rootMargin: '0px 0px 600px 0px' }
      );

    }
  
    connectedCallback() {
      if(this.behaviorButton)this.loadMoreButton.addEventListener('click', this.loadMoreProducts.bind(this));
      if(this.behaviorInifiniteScroll)this.infiniteScrollObserver.observe(this);
    }
  
    renderMoreProducts(url, event) {

        this.loadMoreButton.setAttribute('aria-disabled', true);
        this.loadMoreButton.classList.add('loading');
        this.loadMoreButton.querySelector('.loading__spinner').classList.remove('hidden');

      fetch(url)
        .then(response => response.text())
        .then(responseText => {
          const parser = new DOMParser();
          const nextDoc = parser.parseFromString(responseText, 'text/html');
          const newProducts = nextDoc.querySelector('.product-grid');
          const newLoadMoreButton = nextDoc.querySelector('.load-more');

          if (newLoadMoreButton){
            const newUrl = nextDoc.querySelector('.load-more').dataset.nextUrl;
            if (newUrl) {
              this.nextUrl = newUrl;
            } else {
              // Hide the load more button if there's no more content
              this.loadMoreButton.style.display = 'none';
              // Disconnect the observer after observing an intersection
              this.infiniteScrollObserver.disconnect();
            }
          }
  
          // Append the new products to the existing content
          this.productGrid.insertAdjacentHTML('beforeend', newProducts.innerHTML);
  
          // Optionally, you can trigger additional events or actions here
        })
        .catch(error => {
          console.error('Error:', error);
        })
        .finally(() => {
            this.loadMoreButton.classList.remove('loading');
            if (!this.error) this.loadMoreButton.removeAttribute('aria-disabled');
            this.loadMoreButton.querySelector('.loading__spinner').classList.add('hidden');
        });
    }
  
    loadMoreProducts() {
      this.renderMoreProducts(this.nextUrl, /* Pass event if needed */);
    }
}
  
customElements.define('load-more', LoadMore);
  